export default __webpack_public_path__ + "static/media/accounting-dark.467f05bb.svg";